module.exports = __webpack_public_path__ + "media/images/swPlus-logo-light-d2d5192def1ac61fa8ab505e52de8e99.svg";